module.exports = __webpack_public_path__ + "static/media/logo-shift-white.1f145e33.svg";